import { DataTableSettings } from '@/UI/DataTable';

import type { FilteredListingHeaderCustomActionItem } from './FilteredListingPageHeader';
import type { ListingToolbarActionItem } from './listingToolbarConfig';
import type { DataTableColumn, DataTableLayout } from '@/UI/DataTable/types';

/** Stable id used by FilteredListingGrid to place the sidebar toggle before table settings. */
export const TABLE_SETTINGS_ACTION_ID = 'table-settings';

type BuildTableSettingsActionParams<T> = {
  columns: DataTableColumn<T>[];
  layout: DataTableLayout;
  onChange: (layout: DataTableLayout) => void;
};

/**
 * Declarative `kind: 'custom'` action for DataTableSettings in listing headers/toolbars.
 * Prefer this over copy-pasting the same custom render block on every screen.
 */
export function buildTableSettingsAction<T>({
  columns,
  layout,
  onChange,
}: BuildTableSettingsActionParams<T>): FilteredListingHeaderCustomActionItem &
  Extract<ListingToolbarActionItem, { kind: 'custom' }> {
  return {
    id: TABLE_SETTINGS_ACTION_ID,
    kind: 'custom',
    render: () => (
      <DataTableSettings
        columns={columns}
        layout={layout}
        onChange={onChange}
      />
    ),
  };
}
